<bdo-dashboard-tile
  [tileTitle]="'dashboard.documents.title' | translate"
  [linkData]="linkData"
>
  <div class="bdo-space--bottom re-small">
    {{ 'dashboard.documents.description' | translate }}
  </div>

</bdo-dashboard-tile>
